import React from 'react'
import omit from 'lodash/omit'
export var ODHorizontalSplitLayout = function (props) {
  var constraint = props.constraint,
    width = props.width,
    _a = props.children,
    children = _a === void 0 ? [] : _a,
    _b = props.flexGrows,
    flexGrows = _b === void 0 ? [] : _b
  var styleLeft = omit({
    width: constraint === 'left' && width !== undefined ? width : undefined,
    flexGrow: flexGrows[0],
  })
  var styleRight = omit({
    width: constraint === 'right' && width !== undefined ? width : undefined,
    flexGrow: flexGrows[1],
  })
  // @ts-ignore
  var firstChild = children[0] || 'Provide [0] children'
  // @ts-ignore
  var secondChild = children[1] || 'Provide [1] children'
  return React.createElement(
    'div',
    { className: 'min-w-full flex flex-row' },
    React.createElement('div', { className: 'flex-grow-0', style: styleLeft }, firstChild),
    React.createElement('div', { style: styleRight }, secondChild)
  )
}
//# sourceMappingURL=ODHorizontalSplitLayout.js.map
